import { type NetworkType, type RecipientTypes, type WalletExternalAddress } from '@capsicum/common';
import { useCallback } from 'react';

import { useWalletExternalAddressQuery } from '../data-access/queries';
import { type WalletRecipientItem } from '../models';

/**
 * @param recipientId The recipient ID. undefined disables the query
 * @returns external address information for recipient
 */
export const useWalletWithdrawRecipient = (recipientId: string | undefined) =>
	useWalletExternalAddressQuery(
		recipientId,
		useCallback((data?: undefined | WalletExternalAddress): undefined | WalletRecipientItem => {
			return {
				blockchainAddress: data?.blockchainAddress || '',
				exchange: data?.externalOwnerInfo?.walletOrExchangeName || '',
				id: data?.id || '',
				label: data?.label || '',
				networkType: (data?.network?.type as NetworkType) || '',
				type: (data?.type as RecipientTypes) || ''
			};
		}, [])
	);
